import { API_CALL } from '../../../../../middleware/api';
import { WIDGET_GET_TOTAL_KITS } from './constants';

export const actions = {
  getTotalKits: orgId => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/kits/list',
      params: { limit: 1, orgId },
    },
    type: WIDGET_GET_TOTAL_KITS,
  }),
};
